import { useEffect } from 'react';

import { Box } from '@chakra-ui/react';
import InfiniteScroll from 'react-infinite-scroller';
import { useSelectedView } from 'reducers/viewsSlice';

import NoFeedback from 'assets/assetsV1/illustrations/newIllustrations/noFeedback.svg';

import { sendPageViewEvent } from 'constants/mixpanelHelper';

import { EmptyScreen } from 'uiToolkitV1/EmptyScreen';
import { PaperWithShadow } from 'uiToolkitV1/Paper';
import { SkeletonLoader } from 'uiToolkitV1/SkeletonLoader';

import { PublicPraiseCard } from './components/PublicPraiseCard';
import { useGetInfiniteFeedbackTable } from './hooks/useGetFeedbackTable';

const OrgPraisesIntent = () => {
  const view = useSelectedView();

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, status } = useGetInfiniteFeedbackTable({
    cohortId: view?.id,
    feedbackStatus: 'RECEIVED',
    limit: 10,
  });

  const isEmpty = status === 'success' && data.pages[0]?.values.length === 0;

  useEffect(() => {
    sendPageViewEvent({
      eventProperties: {
        page: 'public praise wall',
      },
    });
  }, []);

  if (status === 'loading') {
    return (
      <Box>
        <PaperWithShadow borderRadius="8px" px={3}>
          <SkeletonLoader />
        </PaperWithShadow>
      </Box>
    );
  }

  if (isEmpty) {
    return (
      <PaperWithShadow borderRadius="8px" px={3}>
        <EmptyScreen
          heading="No praise to show yet"
          description="The praise will appear once someone from your organization shares their praise about you. Keep up the good work!"
          illustrationSrc={NoFeedback}
        />
      </PaperWithShadow>
    );
  }

  return (
    <InfiniteScroll
      loadMore={() => fetchNextPage()}
      // without !isFetchingNextPage it was fetching twice
      // REFER: https://github.com/danbovey/react-infinite-scroller/issues/143#issuecomment-489474949
      hasMore={hasNextPage && !isFetchingNextPage}
      // loader={<div key="loader">Loading...</div>}
    >
      <PaperWithShadow borderRadius="8px" px={3}>
        {data.pages.map((page, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Box key={index}>{page?.values?.map((value) => <PublicPraiseCard key={value.uuid} {...value} />)}</Box>
        ))}
        {isFetchingNextPage && <SkeletonLoader />}
      </PaperWithShadow>
    </InfiniteScroll>
  );
};

export { OrgPraisesIntent };
